import { render, staticRenderFns } from "./homeView.vue?vue&type=template&id=c963e28a&scoped=true&"
import script from "./homeView.vue?vue&type=script&lang=js&"
export * from "./homeView.vue?vue&type=script&lang=js&"
import style0 from "./homeView.vue?vue&type=style&index=0&id=c963e28a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c963e28a",
  null
  
)

export default component.exports